import React, { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { auth, db } from "../../database/firebase";
import { doc, getDoc } from "firebase/firestore";

import { Modal } from "antd";
import {
  Button,
  Cascader,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
  Divider,
  Switch,
} from "antd";
import {
  getStorage,
  query,
  collection,
  getDocs,
  where,
} from "firebase/firestore";
import { openSuccesNotification } from "../../Components/Notifications/succesNotification";
import { validCNP } from "../../utils/cnpValidator";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signOut,
  updateProfile,
} from "firebase/auth";
import { useSelector } from "react-redux";
import { openErrorNotification } from "../../Components/Notifications/errorNotification";
import { getDataDoc, updateDocDatabase } from "../../database";
import { initializeApp } from "firebase/app";
const { TextArea } = Input;
function generateSixDigitCode() {
  return Math.floor(100000 + Math.random() * 900000);
}

function generateUniqueEmail(numeDeFamilie, prenume, cnp) {
  function eliminaDiacritice(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  const prenumeSimplificat = eliminaDiacritice(
    prenume.toLowerCase().trim().replace(/\s+/g, "")
  );
  const numeSimplificat = eliminaDiacritice(
    numeDeFamilie.toLowerCase().trim().replace(/\s+/g, "")
  );

  return `${numeSimplificat}.${prenumeSimplificat}.${cnp}@dobriceansoftware.com`;
}
function AddElev({
  setOpen,
  open,
  confirmLoading,
  setConfirmLoading,
  materiiDefault = [],
  pregatiriDefault = [],
  liceuDefault = "",
  numeDeFamilieDefault = "",
  prenumeDefault = "",
  anDefault = "",
  ziDefault = "",
  typeFacturaDefault = "fizica",
  lunaDefault = "",
  localitateDefault = "",
  clasaDefault = "",
  meditatiiDefault = [],
  numeFirmaDefault = "",
  cifFirmaDefault = "",
  numarRegComDefault = "",
  numeFacturaDefault = "",
  numarTelefonDefault = "",
  adresaEmailDafault = "",
  serieBuletinFacturaDefault = "",
  orasFacturaDefault = "",
  stradaFacturaDefault = "",
  numarBuletinFacturaDefault = "",
  numarAdresaFacturaDefault = "",
  blocFacturaDefault = "",
  apartamentFacturaDefault = "",
  judetFacturaDefault = "",
  facturiNeplatite = [],
  sedinteNeplatite = [],

  numarFacturi = 0,
  contDefault = 0,
  numarMatricolDefault = "",
  id = "",

  parintiDefault = [],
}) {
  const [numeDeFamilie, setNumeDeFamilie] = useState(numeDeFamilieDefault);
  const [prenume, setPrenume] = useState(prenumeDefault);
  const clase = useSelector((state) => {
    let newClass = JSON.parse(JSON.stringify(state.clase));
    newClass.sort((a, b) => {
      if (
        a.anClasa < b.anClasa ||
        (a.anClasa === b.anClasa && a.identificator < b.identificator)
      )
        return -1;
      else return 1;
    });

    return newClass;
  });
  const [clasa, setClasa] = useState(clasaDefault || null);
  const [an, setAn] = useState(anDefault);
  const [numarTelefon, setNumarTelefon] = useState(numarTelefonDefault);
  const [numarMatricol, setNumarMatricol] = useState(numarMatricolDefault);
  const [initiala, setInitiala] = useState("");
  const [parintii, setParintii] = useState(parintiDefault);
  const [cnp, setCnp] = useState("");
  const [mama, setMama] = useState("");
  const [tata, setTata] = useState("");

  const [domiciliu, setDomiciliu] = useState("");
  const [detalii, setDetalii] = useState("");
  const [venitNou, setVenitNou] = useState(true);

  const handleOk = async () => {
    if (clasa === null) {
      openErrorNotification("clasa nu poate fi nula");
      return;
    }
    const cnpTrimmed = cnp.trim();
    if (!cnpTrimmed || cnpTrimmed.length === 0) {
      openErrorNotification("CNP-ul este obligatoriu");
      return;
    }
    if (prenume?.length === 0) {
      openErrorNotification("prenumele nu poate fi nula");
      return;
    }
    if (numeDeFamilie?.length === 0) {
      openErrorNotification("numele de familie nu poate fi nula");
      return;
    }
    
    // Verifică dacă CNP-ul există deja în baza de date (ca string și ca număr)
    const cnpAsString = cnpTrimmed;
    const cnpAsInt = parseInt(cnpTrimmed, 10);
    
    const cnpQueryString = query(
      collection(db, "elevi"),
      where("cnp", "==", cnpAsString)
    );
    
    const cnpQueryInt = query(
      collection(db, "elevi"),
      where("cnp", "==", cnpAsInt)
    );
    
    try {
      const [cnpSnapshotString, cnpSnapshotInt] = await Promise.all([
        getDocs(cnpQueryString),
        getDocs(cnpQueryInt)
      ]);
      
      if (!cnpSnapshotString.empty || !cnpSnapshotInt.empty) {
        openErrorNotification("Există deja un elev cu acest CNP");
        return;
      }
    } catch (error) {
      openErrorNotification("Eroare la verificarea CNP-ului: " + error.message);
      return;
    }
    
    try {
      setConfirmLoading(true);
      const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
      };
      let pass = generateSixDigitCode();

      let Secondary = initializeApp(firebaseConfig, "secondary");
      let auth2 = getAuth(Secondary);
      let idElev = "";
      const adresaEmail = generateUniqueEmail(numeDeFamilie, prenume, cnpTrimmed);
      await createUserWithEmailAndPassword(auth2, adresaEmail, pass)
        .then(async (userCredentials) => {
          const user = userCredentials.user;
          idElev = user.uid;
          await updateProfile(user, { emailVerified: true });
          signOut(auth2);

          await updateDocDatabase("mail", "elev" + pass + Date.now(), {
            to: [adresaEmail].filter(e => e && !e.includes("dobriceansoftware")),
            message: {
              subject:
                numeDeFamilie +
                " " +
                prenume +
                " a fost înregistrat în catalogul școlii",
              html: `
                <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
                  <div style="background-color: #ffffff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                    <div style="text-align: center; margin-bottom: 30px;">
                      <h1 style="color: #2c3e50; margin-bottom: 10px;">🎓 Bine ați venit!</h1>
                      <h2 style="color: #34495e; font-weight: normal; margin: 0;">Ați fost înregistrat în catalogul școlii</h2>
                    </div>
                    
                    <div style="background-color: #e8f4f8; border-left: 4px solid #3498db; padding: 20px; margin: 20px 0; border-radius: 0 5px 5px 0;">
                      <h3 style="color: #2c3e50; margin-top: 0;">Bună ziua, ${numeDeFamilie} ${prenume}!</h3>
                      <p style="color: #34495e; line-height: 1.6; margin-bottom: 0;">
                        Felicitări! Ați fost înregistrat cu succes în catalogul școlar. Vă urăm mult succes la învățătură!
                      </p>
                    </div>
                    
                    <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 20px; margin: 20px 0;">
                      <h3 style="color: #856404; margin-top: 0;">🔑 Datele dumneavoastră de autentificare:</h3>
                      <table style="width: 100%; border-collapse: collapse;">
                        <tr>
                          <td style="padding: 8px 0; color: #495057; font-weight: bold;">Email:</td>
                          <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace;">${adresaEmail}</td>
                        </tr>
                        <tr>
                          <td style="padding: 8px 0; color: #495057; font-weight: bold;">Parolă temporară:</td>
                          <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace; font-weight: bold;">${pass}</td>
                        </tr>
                      </table>
                    </div>
                    
                    <div style="text-align: center; margin: 30px 0;">
                      <a href="${process.env.REACT_APP_LINK}?email=${encodeURIComponent(adresaEmail)}&pass=${pass}" 
                         style="display: inline-block; background-color: #27ae60; color: white; padding: 12px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; box-shadow: 0 3px 6px rgba(39, 174, 96, 0.3);">
                        🚀 Intră în catalog
                      </a>
                      <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;">
                        <p style="color: #6c757d; font-size: 12px; margin: 5px 0;">Dacă butonul nu funcționează, copiați și lipiți acest link în browser:</p>
                        <p style="color: #495057; font-size: 12px; word-break: break-all; margin: 0;">
                          ${process.env.REACT_APP_LINK}?email=${encodeURIComponent(adresaEmail)}&pass=${pass}
                        </p>
                      </div>
                    </div>
                    
                    <div style="background-color: #d4edda; border: 1px solid #c3e6cb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                      <p style="color: #155724; margin: 0; text-align: center;">
                        <strong>💡 Sfat:</strong> Salvați aceste date într-un loc sigur și accesați catalogul pentru a vă vedea notele și temele.
                      </p>
                    </div>
                    
                    <div style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 30px; text-align: center;">
                      <p style="color: #6c757d; font-size: 14px; margin: 0;">
                        Dacă întâmpinați probleme la autentificare, vă rugăm să contactați profesorul sau administratorul.
                      </p>
                    </div>
                  </div>
                </div>
              `,
            },
          });
          await updateDocDatabase("users", user.uid, {
            reset: true,
            type: "elevi",
            uid: user.uid,
            prenume,
            displayName: numeDeFamilie + " " + initiala + " " + prenume,
            initiala,
            numeDeFamilie,
          });
          await updateDocDatabase("elevi", user.uid, {
            prenume,
            numeDeFamilie,
            numarMatricol,
            adresaEmail,
            numarTelefon,
            displayName: numeDeFamilie + " " + initiala + " " + prenume,
            initiala,
            clasa,
            cnp: cnpTrimmed,
            mama,
            tata,
            domiciliu,
            details: detalii,
            venitNou: venitNou,
            inregistrat: Date.now(),
            parintii,
          });
          const elevi = await getDataDoc("claseData", clasa || "faraclasa");

          await updateDocDatabase("claseData", clasa || "faraclasa", {
            elevi: [
              ...(elevi?.elevi || []),
              {
                id: user.uid,
                prenume,
                numeDeFamilie,
                adresaEmail,
                parintii,
                initiala,
              },
            ],
          });
          for await (let email of parintii) {
            let pass = generateSixDigitCode();

            let auth2 = getAuth(Secondary);
            try {
              await createUserWithEmailAndPassword(auth2, email, pass).then(
                async (userCredentials) => {
                  const user = userCredentials.user;
                  await updateProfile(user, { emailVerified: true });
                  await updateDocDatabase("mail", "mail" + pass + Date.now(), {
                    to: [email].filter(e => e && !e.includes("dobriceansoftware")),
                    message: {
                      subject:
                        "Ați fost înregistrat ca părinte abonat pentru elevul " +
                        numeDeFamilie +
                        " " +
                        prenume,
                      html: `
                        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
                          <div style="background-color: #ffffff; border-radius: 10px; padding: 30px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
                            <div style="text-align: center; margin-bottom: 30px;">
                              <h1 style="color: #2c3e50; margin-bottom: 10px;">👨‍👩‍👧‍👦 Bine ați venit!</h1>
                              <h2 style="color: #34495e; font-weight: normal; margin: 0;">Cont părinte creat cu succes</h2>
                            </div>
                            
                            <div style="background-color: #e8f4f8; border-left: 4px solid #3498db; padding: 20px; margin: 20px 0; border-radius: 0 5px 5px 0;">
                              <h3 style="color: #2c3e50; margin-top: 0;">Stimate părinte,</h3>
                              <p style="color: #34495e; line-height: 1.6; margin-bottom: 0;">
                                Ați fost înregistrat ca părinte abonat pentru elevul <strong>${numeDeFamilie} ${prenume}</strong>. 
                                Prin acest cont veți putea urmări progresul școlar al copilului dumneavoastră.
                              </p>
                            </div>
                            
                            <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 20px; margin: 20px 0;">
                              <h3 style="color: #856404; margin-top: 0;">🔑 Datele dumneavoastră de autentificare:</h3>
                              <table style="width: 100%; border-collapse: collapse;">
                                <tr>
                                  <td style="padding: 8px 0; color: #495057; font-weight: bold;">Email:</td>
                                  <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace;">${email}</td>
                                </tr>
                                <tr>
                                  <td style="padding: 8px 0; color: #495057; font-weight: bold;">Parolă temporară:</td>
                                  <td style="padding: 8px 0; color: #212529; font-family: 'Courier New', monospace; font-weight: bold;">${pass}</td>
                                </tr>
                              </table>
                            </div>
                            
                            <div style="text-align: center; margin: 30px 0;">
                              <a href="${process.env.REACT_APP_LINK}?email=${encodeURIComponent(email)}&pass=${pass}" 
                                 style="display: inline-block; background-color: #e74c3c; color: white; padding: 12px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; box-shadow: 0 3px 6px rgba(231, 76, 60, 0.3);">
                                👪 Accesează contul părinte
                              </a>
                              <div style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border-radius: 5px;">
                                <p style="color: #6c757d; font-size: 12px; margin: 5px 0;">Dacă butonul nu funcționează, copiați și lipiți acest link în browser:</p>
                                <p style="color: #495057; font-size: 12px; word-break: break-all; margin: 0;">
                                  ${process.env.REACT_APP_LINK}?email=${encodeURIComponent(email)}&pass=${pass}
                                </p>
                              </div>
                            </div>
                            
                            <div style="background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                              <p style="color: #721c24; margin: 0; text-align: center;">
                                <strong>⚠️ Important:</strong> Din motive de securitate, veți fi obligat să vă schimbați parola la prima autentificare.
                              </p>
                            </div>
                            
                            <div style="background-color: #d1ecf1; border: 1px solid #bee5eb; border-radius: 5px; padding: 15px; margin: 20px 0;">
                              <h4 style="color: #0c5460; margin-top: 0;">📊 Ce puteți face cu acest cont:</h4>
                              <ul style="color: #0c5460; margin-bottom: 0; padding-left: 20px;">
                                <li>Vizualizați notele copilului dumneavoastră</li>
                                <li>Monitorizați temele și proiectele</li>
                                <li>Primiți notificări despre progresul școlar</li>
                                <li>Comunicați cu profesorii</li>
                              </ul>
                            </div>
                            
                            <div style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 30px; text-align: center;">
                              <p style="color: #6c757d; font-size: 14px; margin: 0;">
                                Pentru orice întrebări sau probleme tehnice, vă rugăm să contactați administratorul școlii.
                              </p>
                            </div>
                          </div>
                        </div>
                      `,
                    },
                  });
                  signOut(auth2);
                  await updateDocDatabase("users", user.uid, {
                    reset: true,
                    type: "parinte",
                    emailParinte: email,
                    uid: user.uid,
                    copii: [
                      {
                        adresaEmail,
                        idElev,
                        prenume,
                        displayName: numeDeFamilie + " " + prenume,
                        numeDeFamilie,
                      },
                    ],
                    elevi: [idElev],
                  });
                }
              );
            } catch (err) {
              const q = query(
                collection(db, "users"),
                where("emailParinte", "==", email)
              );
              let data = undefined;

              const querySnapshot = await getDocs(q);
              querySnapshot.forEach((doc) => {
                data = doc.data();
              });
              if (data?.uid)
                await updateDocDatabase("users", data.uid, {
                  copii: [
                    ...data.copii,
                    {
                      adresaEmail,
                      idElev,
                      prenume,
                      displayName:
                        numeDeFamilie + " " + initiala + " " + prenume,
                      numeDeFamilie,
                    },
                  ],
                  elevi: [...(data.elevi || []), idElev],
                });
            }
          }
          openSuccesNotification("Elevul a fost adaugat");
        })
        .catch((err) => {
          openErrorNotification(err.message);
          setConfirmLoading(false);
        });

      setOpen(false);

      setConfirmLoading(false);
    } catch (err) {
      openErrorNotification(err.message);
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      title="Adaugă Elev"
      open={open}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      width={window.innerWidth <= 768 ? "100vw" : "95vw"}
      style={{
        maxWidth: window.innerWidth <= 768 ? "none" : "1400px",
        top: window.innerWidth <= 768 ? 0 : 20,
      }}
      bodyStyle={{
        height: window.innerWidth <= 768
          ? "calc(100vh - 180px)"
          : "calc(100vh - 200px)",
        overflow: "auto",
        padding: window.innerWidth <= 768 ? "12px" : "24px",
      }}
    >
      <Form
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 18,
        }}
        layout="horizontal"
        onValuesChange={() => {}}
      >
        <Form.Item label="Nume">
          <Input
            value={numeDeFamilie}
            onChange={(e) => {
              setNumeDeFamilie(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Prenume">
          <Input
            value={prenume}
            onChange={(e) => {
              setPrenume(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Initiala">
          <Input
            value={initiala}
            onChange={(e) => {
              setInitiala(e.target.value);
            }}
          />
        </Form.Item>

        <Form.Item label="Nr. Matricol">
          <Input
            value={numarMatricol}
            onChange={(e) => {
              setNumarMatricol(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Telefon">
          <Input
            value={numarTelefon}
            onChange={(e) => {
              setNumarTelefon(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="CNP" required>
          <Input
            value={cnp}
            onChange={(e) => {
              setCnp(e.target.value);
            }}
            placeholder="CNP-ul elevului (obligatoriu)"
          />
        </Form.Item>

        <Form.Item label="Domiciliu">
          <Input
            value={domiciliu}
            onChange={(e) => {
              setDomiciliu(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Prenume Mama">
          <Input
            value={mama}
            onChange={(e) => {
              setMama(e.target.value);
            }}
          />
        </Form.Item>
        <Form.Item label="Prenume Tata">
          <Input
            value={tata}
            onChange={(e) => {
              setTata(e.target.value);
            }}
          />
        </Form.Item>

        <Form.Item label="Venit Nou" tooltip="Dacă e marcat va aparea la finalul catalogului marcând că e venit nou">
          <Switch
            checked={venitNou}
            onChange={(checked) => setVenitNou(checked)}
          />
        </Form.Item>

        {!clasaDefault && (
          <Form.Item label="Clasa" required>
            <Select
              onChange={(e, value) => setClasa(value.value)}
              options={[
                ...clase.map((cls) => {
                  return {
                    label: cls.anClasa + cls.identificator,
                    value: cls.id,
                  };
                }),
                { label: "N/A", value: "faraclasa" },
              ]}
            />
          </Form.Item>
        )}

        <Form.Item label="Email Abon.">
          <Select
            mode="tags"
            style={{
              width: "100%",
            }}
            placeholder="Parinti"
            onChange={(e) => setParintii(e.map((item) => item.trim()))}
            options={[]}
          />
        </Form.Item>
        <Form.Item label="Detalii" tooltip="În aceste detalii se pot scrie detalii transfer/ orice informații care vor să apară în catalogul printat">
          <Input
            value={detalii}
            onChange={(e) => {
              setDetalii(e.target.value);
            }}
            placeholder="Detalii transfer sau alte informații pentru catalog"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddElev;
